<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pengguna</h1>
            
          </div>
        <div class="section-body">
            <h2 class="section-title">Buat Pengguna Baru</h2>
            <p class="section-lead">Buat pengguna baru.</p>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Utama</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>* Username</label>
                                <input type="text" v-model="username" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>* Password</label>
                                <input type="password" class="form-control" required v-model="password" >
                            </div>
                            <div class="form-group">
                                <label>* Nama User</label>
                                <input type="text" v-model="user_fullname" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Role</label>
                                <select id="user_role" class="form-control select2">
                                    <option v-for="option in roleList" v-bind:key="option.id_level" :value="option.id_level" >{{ option.deskripsi_level}} </option>
                                </select>
                            </div>
                            <!-- <div class="form-group row">
                                <label class="col-sm-3 col-form-label">Bisa Melihat Harga?</label>
                                <div class="col-sm-9">
                                    <toggle-button 
                                        style="display:block;"
                                        v-model="is_price" 
                                        :value="true" 
                                        color="#3DDCF7" :sync="true" 
                                        :labels="{checked: 'Ya', unchecked: 'Tidak'}"
                                        :width="80"
                                        :height="30"
                                        :font-size="14"
                                    />
                                </div>
                            </div> -->
                            <div class="form-group row">
                                <label class="col-sm-3 col-form-label">Aktifkan?</label>
                                <div class="col-sm-9">
                                    <toggle-button 
                                        style="display:block;"
                                        v-model="user_status" 
                                        :value="true" 
                                        color="#3DDCF7" :sync="true" 
                                        :labels="{checked: 'Ya', unchecked: 'Tidak'}"
                                        :width="80"
                                        :height="30"
                                        :font-size="14"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 text-center">
                    <button @click="$router.go(-1)" class="btn btn-danger">Kembali</button>
                    <button @click="submit('normal')" class="btn btn-primary">Buat Pengguna</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>

export default {
    data() {
        return {
            username : '',
            password : '',
            user_fullname : '',
            user_role : '',
            is_price : false,
            user_status : false,
            roleList : []
        }
    },
    mounted() {
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#user_role").select2(); 
            }, 100);
        });
    },
    methods : {
        init: function () {
            this.$http.get('User/getRoleList').then( result => {
                if(result.data.code == '01') {
                    this.roleList = result.data.detail
                }
            })
        },
        submit: function() {
            if(this.username == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Username harus diisi !',
                    type : 'warning'
                }   
                return false;
            }
            
            if(this.password == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Password harus diisi !',
                    type : 'warning'
                }   
                return false;
            }

            if(this.user_fullname == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Nama User harus diisi !',
                    type : 'warning'
                }   
                return false;
            }
            this.$root.is_loading = true

            this.user_role = $("#user_role").select2('val')

            var formsub = new FormData()
            formsub.append('user_login',this.username);
            formsub.append('user_password', this.password);
            formsub.append('user_fullname', this.user_fullname);
            formsub.append('id_level', this.user_role);
            formsub.append('user_status', this.user_status);

            this.$http.post('user/addNewUser', formsub).then( result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'User Berhasil Dibuat !',
                        type : 'success'
                    }
                    this.$root.is_loading = false
                    this.$router.go(-1);
                }else if(result.data.code == '02') {
                    this.$parent.toastr = {
                        title : 'Warning',
                        message: result.data.message,
                        type : 'warning'
                    }
                    this.$root.is_loading = false
                }
            })

        },
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/user/NewUser.vue